<div class="informativo">


    <div class="tituloOpcion">

        <div class="opcion" *ngIf="opcionesVentas && validarOpcionRol(constantesOpciones.REPORTE_VENTAS_QUINTE) || validarOpcionRol(constantesOpciones.INFORME_VENTA_BANCA_RECARGAS_POR_VENDEDOR)">
            <div class="opcion_titulo" (click)="opcionSeleccionada('ventaLoteriaOtrosProductos')" [ngClass]="ventasOtrosProductos ? 'select':''" *ngIf="opcionesVentas && validarOpcionRol(constantesOpciones.INFORME_VENTA_BANCA_RECARGAS_POR_VENDEDOR)"><p>Lotería/Otros productos</p></div>
            <div class="opcion_titulo" (click)="opcionSeleccionada('ventasQuinte')"[ngClass]="ventasQuinte ? 'select':''" *ngIf="opcionesVentas && validarOpcionRol(constantesOpciones.REPORTE_VENTAS_QUINTE)"><p>Quinte +</p></div>
        </div>
        <div class="opcion" *ngIf="opcionesPremios && validarOpcionRol(constantesOpciones.REPORTE_PREMIOS_QUINTE)">
            <div class="opcion_titulo" (click)="opcionSeleccionada('premiosQuinte')" [ngClass]="premiosQuinte ? 'select':''"><p>Quinte +</p></div>
        </div>
        <div class="opcion" *ngIf="opcionesAnulados && validarOpcionRol(constantesOpciones.REPORTE_ANULADOS_QUINTE)">
            <div class="opcion_titulo" (click)="opcionSeleccionada('anuladosQuinte')" [ngClass]="anuladosQuinte ? 'select':''"><p>Quinte +</p></div>
        </div>

        <!-- <div class="titulo">
            <h5>{{titulo}}</h5>
        </div> -->
    </div>


</div>